var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"ArticleViewMp text-left",attrs:{"data-title":"详情"}},[_c('ArticleDetailCom',{attrs:{"fetchDetailApi":_vm.getArticleDetailMp,"detailId":_vm.$route.params.id,"type":_vm.$route.params.type,"isMp":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }